import React, { useState, ChangeEvent } from "react";
import './Input.css'

interface InputProps {
	id: string
	label: string
	description?: string
	placeholder?: string
	errorMessage?: string
	isRequired?: boolean
	value: string | undefined
	onChange: (value: string) => void
	handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
}

const Input: React.FC<InputProps> = ({
	id,
	label,
	description,
	placeholder,
	errorMessage,
	isRequired = false,
	value,
	onChange,
	handleBlur,
}) => {

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		onChange(e.target.value)
	}

	return (
		<div className="input-container">
			<p className="input-label">
				<label htmlFor={id}>{label}</label>
				{isRequired && <span className="input-required">*</span>}
			</p>
			{description && <p className="input-description">{description}</p>}
			<input type="text" id={id} name={id} onChange={handleChange} onBlur={handleBlur} value={value} placeholder={placeholder} />
			<div className="input-error-message">{errorMessage}</div>
		</div>
	)
}

export default Input